// BrowseTab.js
import { connect } from 'react-redux';

import { HOME_CONTENT_TABS } from '../RemoteConfigKeys.js';
import BrowseTab from '../component/BrowseTab.jsx';
import { replace } from '../action/navigationAction.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import { SEARCH_MODAL_ID } from '../resource/searchConstants.js';

const mapStateToProps = state => {
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const isSearchModalOpened = ['opening', 'display'].includes(
    getModalData(state, SEARCH_MODAL_ID, 'status')
  );
  const shouldRenderSearchBar = !isSearchModalOpened;
  return {
    isAuthed,
    tabs: getRemoteConfigData(state, HOME_CONTENT_TABS),
    shouldRenderSearchBar,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: (...args) => dispatch(replace(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowseTab);
